<template>
  <nav v-if="$route.name !== 'parcheggi'">
    <router-link to="/">Tavolo</router-link> |
    <router-link to="/PrenotazioneAsporto">Asporto</router-link> |
    <router-link to="/about">Informazioni</router-link>
  </nav>
  <router-view></router-view>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
